/**
 * Removes whitespace from the specified input string
 *
 * @param subject string from which to remove whitespace
 * @returns string with whitespace removed
 */
export function stringRemoveWhitespace(subject) {
    // remove whitespace
    return subject.replace(/\s+/g, '');
}
//# sourceMappingURL=stringRemoveWhitespace.js.map